import React from "react";

import Default from './html/Default';
import Edited from './html/Edited';

const Html = (props) => {
  const { meta: { edit } } = props;

  return edit ? <Edited {...props}/> : <Default {...props}/>;
};

export default Html;
